<script lang="ts">
    import type { Res } from "@repo/backend/client";
    import type { ThreadId, TransactionId } from "@repo/backend/types";
    import CaseView from "../../lib/components/case-view.svelte";

    type Transaction = Res["Get dashboard transactions"]["rows"][number];

    interface Props {
        transaction: Transaction;
    }

    const { transaction }: Props = $props();
</script>

<CaseView
    threadId={transaction.threadId as ThreadId}
    transactionId={transaction.suggestedTransactionId as TransactionId}
    diffMode={true}
/>
